/*
 * @Description: 城市专场
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 12:09:39
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-03-06 16:56:19
 */
import React, { useEffect, useState } from 'react' ;
import SelfBlock from './selfblock' ;
import { Log } from '../../util/empty' ;
import Cookie from '../../util/cookie' ;
import { getCid , getCname} from '../../util/helper' ;

const  List = [
  {
    id : 1 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 2 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 3 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 4 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 5 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 6 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
]

const CityBlock = (props) => {
  const [sortdata, setsortdata] = useState([]) ;
  useEffect(() => {
    // console.log('indexcity',props);
    let curindex ,temparr = [] ;
    props.data.map((item,index) => {
      if(item.c_name == getCname()){
        curindex = index ;
      }
    }) ;
    temparr = props.data.slice(curindex,curindex+1).concat(props.data.slice(0,curindex)).concat(props.data.slice(curindex+1)) ;
    // console.log('curindex',curindex,temparr) ;
    setsortdata(temparr) ;
  },[])

  const getCurName = () => {
   let city = Cookie.get('commontopbar_ipcity') ? decodeURI(Cookie.get('commontopbar_ipcity')).split("|")[0] : "bj" ;
   return city ;
  }

  const addempty = () => {
    Log(`cfVRMoreClick`) ;
  }
  
  return(
    sortdata.length > 0 ?
    <div className="city-block">
      <div className="city-block-title"></div>
        <div className="city-block-content">
          {
            sortdata.map((item, index) => {
              return (
                <SelfBlock data={item} key={item.id}/>
              )
            })
          }
        </div>
      <p className="look-more" onClick={addempty}>
        <a href={`//${getCurName()}.58.com/job.shtml`} target="_blank">查看更多</a>
      </p>
    </div>
    : ""
  )
}

export default CityBlock ;